import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function subscribe(onChange: () => void) {
  if (!window.matchMedia) return () => {};

  const mediaQuery = window.matchMedia(QUERY);
  mediaQuery.addEventListener('change', onChange);

  return () => {
    mediaQuery.removeEventListener('change', onChange);
  };
}

function getSnapshot() {
  return window.matchMedia ? window.matchMedia(QUERY).matches : false;
}

/**
 * Whether the user has asked the system to reduce motion. Follows changes to
 * the setting while the component is mounted.
 *
 * @return Whether reduced motion is requested.
 */
export default () => useSyncExternalStore(subscribe, getSnapshot);
